module.exports = fox._r("images/promo/tutorial/10.png", __webpack_public_path__ + "_/common/images/promo/tutorial/10.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/10.png
// module id = 658
// module chunks = 2